import Vue from 'vue'
import App from './App.vue'

import router from '@/apps/open/router'
import '@/apps/open/router/interceptor'

import store from '@/apps/open/store'

import '../../registerServiceWorker'

import csrftoken from '@/apps/open/utils/csrftoken'
import axios from 'axios'
import VueLazyload from 'vue-lazyload'

import '@/apps/open/plugins/element' // element-ui
import '@/apps/open/plugins/component' // 自定义组件
import '@/apps/open/plugins/lib' // 第三方组件
import '../../styles/index.scss'

import { priSubPath } from '@/apps/open/constants/index'

Vue.use(VueLazyload, {
  preLoad: 2
})

// handle window.open in private project
if (process.env.VUE_APP_IS_PRIVATE) {
  const pathValue = location.pathname
  const openFn = window.open
  window.open = function (url?: string | undefined, target?: string | undefined, features?: string | undefined, replace?: boolean | undefined, isAdapt?: any): any {
    if (url && !isAdapt && !/^(https:\/\/)|(http:\/\/)|(\/\/)/.test(url)) {
      openFn(`${pathValue}${url}`, target, features, replace)
    } else {
      openFn(url, target, features, replace)
    }
  }
}

// TODO 跨域问题
axios.defaults.headers = {}
axios.defaults.withCredentials = true
csrftoken()

Vue.config.productionTip = false

declare module 'vue/types/vue' {
  interface Vue {
    $eventBus: any
  }
}

Vue.prototype.$eventBus = (function () {
  let events: any = {}
  return {
    $on (name: string, fn: Function) {
      if (!events[name]) {
        events[name] = []
      }
      events[name].find((exist_fn: Function) => {
        return exist_fn === fn
      })
      !events[name].find((exist_fn: Function) => exist_fn === fn) && events[name].push(fn)
    },
    $emit (name: string) {
      if (events[name] && events[name].length > 0) {
        events[name].forEach((fn: Function) => fn())
      }
    },
    /**
     * 取消指定的订阅函数
     * @param name 取消订阅名
     * @param fn 取消订阅函数
     */
    $clear (name: string, fn: Function) {
      let fnIdx = events[name].indexOf(fn)
      if (fnIdx > -1) {
        events[name].splice(fnIdx, 1)
      }
    }
  }
})()

new Vue({
  router,
  store,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
